import React from "react";
import { Dropdown, Spin } from "antd";
import { DownOutlined } from "@ant-design/icons";
import style from "css/admin/component.module.css";

function SearchDropdown({
    label,
    items,
    selectedKey,
    selectedLabel,
    onChange,
    placement = "bottomLeft",
    width,
    loading = false,
    disabled = false,
}) {
    const handleMenuClick = (e) => {
        if (loading || disabled) return;
        const found = items.find((item) => item.key === e.key);
        if (found) {
            const labelText =
                typeof found.label === "string" ? found.label : String(found.key);
            onChange && onChange(e.key, labelText);
        }
    };

    const normalizedItems = (items || []).map((item) => {
        const isStringLabel = typeof item?.label === "string";
        const labelText = isStringLabel ? item.label : undefined;

        return {
            ...item,
            label: isStringLabel ? (
                <span className={style.dropdown_menu_item_label} title={labelText}>
                    {labelText}
                </span>
            ) : (
                item.label
            ),
        };
    });

    const menuItems = (() => {
        if (loading) {
            return [
                {
                    key: "__loading__",
                    disabled: true,
                    label: (
                        <span className={style.dropdown_menu_item_label}>
                            <Spin size="small" /> 로딩중...
                        </span>
                    ),
                },
            ];
        }
        if (!normalizedItems || normalizedItems.length === 0) {
            return [
                {
                    key: "__empty__",
                    disabled: true,
                    label: (
                        <span className={style.dropdown_menu_item_label}>
                            데이터 없음
                        </span>
                    ),
                },
            ];
        }
        return normalizedItems;
    })();

    const menuProps = {
        items: menuItems,
        onClick: handleMenuClick,
        selectable: true,
        selectedKeys: selectedKey ? [selectedKey] : [],
    };

    const displayLabel = (() => {
        if (selectedLabel != null && selectedLabel !== "") return selectedLabel;
        const found = items?.find((i) => i.key === selectedKey);
        return found ? found.label : "";
    })();

    const displayTitle = typeof displayLabel === "string" ? displayLabel : undefined;

    return (
        <Dropdown
            menu={menuProps}
            trigger={disabled || loading ? [] : ["click"]}
            placement={placement}
            arrow
        >
            <div
                className={style.dropdown_trigger}
                style={{
                    ...(width != null ? { width } : null),
                    ...(disabled || loading ? { cursor: "not-allowed", opacity: 0.7, pointerEvents: "none" } : null),
                }}
                aria-disabled={disabled || loading}
            >
                <span className={style.dropdown_trigger_label} title={displayTitle}>
                    {displayLabel}
                </span>
                {loading ? <Spin size="small" /> : <DownOutlined style={{ fontSize: 18 }} />}
            </div>
        </Dropdown>
    );
}

export default SearchDropdown;
